import { IApplicationContext } from '../../../../shared/types';
import { createReduxStore } from '../../../../shared/utils/redux';
import { IThunkContext } from '../../../../shared/types/thunk';
import { getPaymentWidgetMicrofrontendAPI } from '../../../demo/services/getPaymentWidgetMicrofrontendAPI';

export function createApplicationState({ telemetry, logger, config, httpApi }: IApplicationContext) {
  const paymentWidgetMicrofrontend = getPaymentWidgetMicrofrontendAPI();

  const thunkContext: IThunkContext = { config, httpApi, logger, telemetry, paymentWidgetMicrofrontend };

  return createReduxStore(thunkContext);
}
